import moment from 'moment';
import React from 'react';

const SubscriberForm = ({ handleSubscriberForm, subscriberForm, selectedTemplate }) => {
    return (
        <div className="d-flex flex-row align-items-end mt-1">
            <div className="mr-4" style={{ width: '5%' }}>
                <p className="m-0 mr-1 mt-1">PU ID</p>
                <input
                    type="number"
                    value={subscriberForm.puid}
                    onChange={(e) => handleSubscriberForm('puid', e.target.value)}
                />
            </div>
            <div className="mr-4" style={{ width: '12%' }}>
                <p className="m-0 mr-1 mt-1">SUs registered
                    <span style={{ fontSize: 12 }}> *after date</span>
                    <div style={{ fontSize: 12 }}>
                        *fraudlent SUs excluded
                    </div>
                </p>
                <input
                    type="date"
                    value={subscriberForm.SuRegisteredDate}
                    onChange={(e) => handleSubscriberForm('SuRegisteredDate', e.target.value)}
                />
            </div>
            <div className="mr-4" style={{ width: '5%' }}>
                <p className="m-0 mr-1 mt-1">Min pay</p>
                <input
                    type="number"
                    value={subscriberForm.minPay}
                    onChange={(e) => handleSubscriberForm('minPay', e.target.value)}
                />
            </div>
            <div style={{ width: '15%' }}>
                <p className="m-0 mr-1 mt-1">Max Subscribers</p>
                <input
                    type="number"
                    style={{ width: '35%' }}
                    value={subscriberForm.maxSubscribers}
                    onChange={(e) => handleSubscriberForm('maxSubscribers', e.target.value)}
                />
            </div>
            <div style={{ width: '15%' }}>
                <p className="m-0 mr-1 mt-1">Last SU registered date</p>
                <input
                    type="text"
                    style={{ width: '65%' }}
                    value={selectedTemplate && selectedTemplate.last_registered_date
                        ? moment.utc(selectedTemplate.last_registered_date).local().format('ll')
                        : ''
                    }
                    disabled
                />
            </div>
        </div>
    );
};
export default SubscriberForm;